import React from 'react';
import responsiveScreen from 'src/assets/images/responsive.svg';

const MobileTabletIncompatible = () => {
  return (
    <div className="mobile-tablet-incompatible">
      <div className="incompatible-container">
        {/* Mock browser card - top */}
        <img src={responsiveScreen} alt="Mobile Tablet Incompatible" />

        {/* Copy section - bottom */}
        <div className="copy-section">
          <div className="copy-block">
            <p className="min-width-note">
              Minimum screen width: 1024px • Desktop or laptop recommended
            </p>
            <h1 className="main-title text-center">Hector works best on desktop</h1>
            <p className="description text-center">
              Our platform is optimized for desktop and laptop screens for the best experience.
            </p>
            <div className='d-flex align-items-center justify-content-center gap-6 w-100 f-14'>
              Need help? 
              <a
                href="mailto:support@hectorai.live"
                className="help-link"
                rel="noopener noreferrer"
              >
                support@hectorai.live
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileTabletIncompatible;
